import { Box, Card, CardContent, Divider, Typography } from "@mui/material";
import CustomTable from "./CustomTable";

const date = (value) => (value ? new Intl.DateTimeFormat("cs-CZ").format(new Date(value)) : "bez omezení");
const money = (value) => (value == null ? "-" : new Intl.NumberFormat("cs-CZ", { style: "currency", currency: "CZK" }).format(value));
const text = (value) => (value == null || value === "" ? "-" : String(value));

function Value({ label, children }) {
  return <Box>
    <Typography variant="caption" color="text.secondary">{label}</Typography>
    <Typography variant="body2">{children}</Typography>
  </Box>;
}

function Section({ title, children }) {
  return <Box sx={{ pt: 2.5 }}>
    <Typography variant="subtitle1" color="primary" sx={{ fontWeight: 600, mb: 1.5 }}>{title}</Typography>
    {children}
  </Box>;
}

function Contract({ contract }) {
  const itemColumns = [
    {
      id: "sluzba",
      label: "Služba",
      renderCell: (_, item) => `${item.sluzba || "-"}${item.zpusobMereni ? ` · ${item.zpusobMereni}` : ""}`,
    },
    {
      id: "cisloOm",
      label: "Odběrné místo",
      renderCell: (_, item) => item.cisloOm || item.idOdberneMisto || "-",
    },
    {
      id: "platnost",
      label: "Platnost",
      renderCell: (_, item) => `${date(item.platnostOd)} – ${date(item.platnostDo)}`,
    },
    {
      id: "mnozstvi",
      label: "Množství",
      renderCell: (value, item) => value == null ? "-" : `${value}${item.periodaMnozstvi ? ` · ${item.periodaMnozstvi}` : ""}`,
    },
  ];

  return <Card key={contract.idpk} variant="outlined" sx={{ mb: 2 }}>
    <CardContent sx={{ p: { xs: 2, sm: 3 }, "&:last-child": { pb: { xs: 2, sm: 3 } } }}>
      <Typography variant="h6">Smlouva č. {contract.cisloSmlouvy}{contract.verze ? ` / verze ${contract.verze}` : ""}</Typography>

      <Section title="Hlavička smlouvy">
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" }, gap: 2 }}>
          <Value label="Platnost">{date(contract.platnostOd)} – {date(contract.platnostDo)}</Value>
          <Value label="Splatnost">{contract.splatnost == null ? "-" : `${contract.splatnost} dní`}</Value>
          <Value label="Vyúčtování">{text(contract.periodicitaVyuctovani)}</Value>
        </Box>
      </Section>

      <Divider sx={{ mt: 2.5 }} />
      <Section title="Informace o zálohách">
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" }, gap: 2 }}>
          <Value label="Způsob">{text(contract.zpusobZalohy)}</Value>
          <Value label="Částka">{money(contract.zalohaCastka)}{contract.periodicitaZalohy ? ` · ${contract.periodicitaZalohy}` : ""}</Value>
          <Value label="Variabilní symbol">{text(contract.variabilniSymbol)}</Value>
          <Value label="SIPO">{text(contract.cisloSipo)}</Value>
        </Box>
      </Section>

      <Divider sx={{ mt: 2.5 }} />
      <Section title="Položky smlouvy">
        {!contract.polozky?.length ? <Typography variant="body2" color="text.secondary">Smlouva nemá žádné aktuální položky.</Typography> : (
          <Box
            sx={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              overflowX: "auto",
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 1,
              "& .MuiTableContainer-root": { minWidth: 0 },
            }}
          >
            <CustomTable columns={itemColumns} data={contract.polozky} getRowKey={(item) => item.idpk} pagination={false} />
          </Box>
        )}
      </Section>
    </CardContent>
  </Card>;
}

export default function SmlouvySection({ contracts }) {
  return <Box sx={{ mt: 4, mb: 5 }}>
    <Typography variant="h6" color="primary" sx={{ mb: 1 }}>Smlouvy</Typography>
    {!contracts?.smlouvy?.length ? <Typography variant="body2">Nemáte žádnou aktivní smlouvu.</Typography> : contracts.smlouvy.map((contract) => <Contract key={contract.idpk} contract={contract} />)}
  </Box>;
}
